import styled from 'styled-components';
const DropdownHeader = styled.div.withConfig({
  displayName: "DropdownHeader",
  componentId: "sc-1vsx0c-0"
})(["width:100%;padding:var(--size-spacing-04);border-bottom:1px solid var(--neutral-border);"]);
DropdownHeader.displayName = 'Dropdown.Header';
export default DropdownHeader;